import type { API } from 'chessboard/api/config/types';
import type JCE from '@chesscom/js-chess-engine';

/**
 * Create the getMaterial method.
 */
export function createGetMaterial(context: API.Context) {
  /**
   * Get the material count.
   */
  return function getMaterial(): JCE.Piece.Material {
    const { game } = context;

    return game.material();
  };
}
